import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<h4 class="mb-3 bold text-center">Al poeto dum revolucio</h4>

		<div class="poem">
		
			<p class="poem-block mb-3">
				Ritm’ de l’ kreaĵo naskiĝu el mov’ de remil’ kontraŭflua.<br/>
				En milita tumult’ kaj senord’ ekkompreni la kernon, <br/>
				Esti tuto, ne part’; ne por unu ekstrem’, sed por ambaŭ.<br/>
				Ĝuas la Ludon spektant’, - sed vi – nek aktor’, nek spektanto,<br/>
				Vi – kunludanto de l’ Sort’, kiu kreis kaj gvidas la Dramon.<br/>
				Esti dum revoluci’ la Homo, sed ne Civitano,<br/>
				Scii, ke ajnaj standardoj, partioj, programoj<br/>
				Estas nur list’ de malsanoj por frenezulejkuracisto.<br/>
				Esti pario dum ĉiuj potenc- kaj popolmastrumadoj.<br/>
				Poet’ – konscienc’ de l’ popol’. En ŝtat’ ne troviĝas poetoj. 
			</p>
			<p style="text-align: right;">(1925 j.)</p>

		</div>
	`
	)
}

const itemName = {
	esp: 'Maksimilian Voloŝin'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;